import isFunction from "lodash/isFunction";
import isUndefined from "lodash/isUndefined";
import { t } from "../helpers/localization";
import sendCommand from './webSendCommand2Client'
import { sendWebNotification } from "./webNotifications";
import settings from "../settings"

export const isIngameBrowser = () => {
  return window.navigator.userAgent.indexOf('WOWS/1') !== -1;
};

export interface SendNotificationProps {
  hasHeader?: boolean,
  header: any,
  message: any,
  cost?: number,
  currency?: string,
  isError?: boolean
}

export interface SendNotificationParams {
  hasHeader: boolean,
  header: any,
  message: any,
  isError?: boolean,
  cost?: number,
  currency?: string
}

export const sendNotification = ({
  hasHeader = false,
  header,
  message,
  cost,
  currency,
  isError = false
}: SendNotificationProps) => {

  let params: SendNotificationParams = {
    hasHeader,
    header,
    message,
    isError
  };

  if (!isUndefined(cost)) {
    params.cost = cost;
    params.currency = currency || 'gold';
  }

  if (isFunction(window.jsHostQuery)) {
    sendCommand({
      command: 'notification',
      params: params
    });
  } else {
    sendWebNotification(params);
  }
};

export interface SendErrorNotificationProps {
  header?: any
  message?: any
}

export const sendErrorNotification = ({
  header,
  message
}: SendErrorNotificationProps) => {
  message = message || t('Техническая ошибка');
  sendNotification({
    hasHeader: true,
    header: `<span class="bold_error">${header}</span>`,
    message,
    isError: true
  });
};

export const openAccountProfile = (accountId: string) => {
  if (!window.jsHostQuery && settings.profileUrl) {
    window.open(settings.profileUrl.replace('{accountId}', accountId), "_blank")
  }
  sendCommand({
    command: 'action',
    params: {
      actionId: 'openAccountProfile',
      accountId
    }
  });
};

export const openChatWindow = (accountId: string, nickname: string) => {
  sendCommand({
    command: 'action',
    params: {
      actionId: 'openChatWindow',
      accountId,
      nickname
    }
  });
};


export interface PlaySoundProps {
  soundsetName: string,
  action: string,
}
export const playSound = ({
  soundsetName,
  action
}: PlaySoundProps) => {
  sendCommand({
    command: 'sound',
    params: {
      soundsetName,
      action
    }
  });
};

export const closeBrowser = () => {
  sendCommand({
    command: 'action',
    params: {
      actionId: 'closeBrowser'
    }
  });
};

export const openUrlInExternalBrowser = url => {
  if (!url) {
    return;
  }

  sendCommand({
    command: 'action',
    params: {
      url: url,
      actionId: 'openExternalBrowser'
    }
  });
};

export const sendCountingCWarsAttempts = (accountId, isCounting) => {
  sendCommand({
    command: 'action',
    params: {
      actionId: 'toggleCountingCWarsAttempts',
      accountId,
      isCounting
    }
  });
};